const statuses = [
    {value: '', label: 'Select status'},
    {value: 'active', label: 'Enabled'},
    {value: 'inactive', label: 'Disable'},
]

export default statuses
